module.exports = __webpack_public_path__ + "static/media/papua-new-guinea.f3c16c1f.svg";